/**
 * 灶上的菜谱（纯数据）。
 *
 * 规矩：做出来就趁热吃了，不进背包——碗是空的，肚子是实的。
 *   need  — 要什么料（料不够就做不成）
 *   heat  — 这一道要多少火候（「做吃的」这个标签的份量），不够就容易失手
 *   qi    — 要用自身灵气吊着的几道（修行与灶上在这一处接上了）
 *   effect— 下肚之后：饱腹 / 精力 / 心情 / 灵气
 *   perk  — 附带的好处（目前只有「清心」：这一天更容易想通事情）
 *   cert  — 讲究的菜要手上有那张灶上的照才做得出来（照的兑现，见 data/inspire.js）
 *
 * 闭环：地里收的菜、河里的鱼、采来的草药 -> 灶上；
 *       灶上出去的路有三条：自己吃、端出去施食（人情）、讲究的菜卖给铺子。
 */

export const RECIPES = [
  {
    id: 'rice', name: '糙米饭', need: { rice: 1 }, heat: 0,
    effect: { satiety: 30, energy: 5 },
    text: '一碗热饭下肚，身上暖了。', failText: '火太急，米饭夹生。',
  },
  {
    id: 'soup', name: '青菜汤', need: { veg: 2, water: 1 }, heat: 8,
    effect: { satiety: 18, mood: 6, qi: 1 },
    text: '一碗清汤，青菜还是脆的。', failText: '汤煮过了头，菜叶发黄。',
  },
  {
    id: 'roastFish', name: '烤鱼', need: { commonFish: 1 }, heat: 12,
    effect: { satiety: 26, mood: 4, energy: 3 },
    text: '鱼烤得滋滋响，香味顺着院子飘。', failText: '一面焦了，鱼肉发柴。',
  },
  {
    id: 'herbMeal', name: '草药膳', need: { herb: 2, veg: 1 }, heat: 16, cert: 'cook_1',
    effect: { satiety: 12, energy: 15, mood: 3 },
    text: '苦是苦了点，喝完身上轻快。', failText: '药味压过了菜味，喝得直皱眉。',
  },
  {
    id: 'clearHeart', name: '清心汤', need: { herb: 3, water: 1 }, heat: 24, qi: 20, cert: 'cook_2',
    effect: { satiety: 6, mood: 10 }, perk: 'clearHeart',
    text: '汤气一升，心里那层浮尘落了下去。', failText: '心没静下来，白糟践了三味草药。',
  },
  {
    id: 'feast', name: '待客的一桌', need: { rice: 1, veg: 2, commonFish: 1, water: 1 }, heat: 30, cert: 'cook_3',
    effect: { satiety: 35, mood: 12, energy: 8 },
    text: '一桌子菜端上来，先请的该是街坊。', failText: '桌上的菜没配好，自己先吃了闷亏。',
  },
];
